import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6E6EB8",
      stroke: "#6E6EB8",
      "stroke-linejoin": "round",
      "stroke-width": ".956",
      d: "M11.204 25.229c0-1.692-.506-4.24-2.01-6.35-1.441-2.02-3.815-3.67-7.636-3.771l-.374-.005-.097-.01a.478.478 0 0 1 .097-.946l.413-.006c2.034-.06 3.627-.557 4.877-1.316 1.334-.811 2.303-1.937 3.005-3.203 1.412-2.547 1.725-5.633 1.725-7.722a.477.477 0 0 1 .946-.097l.01.097.004.403c.04 2.07.397 4.931 1.72 7.319.703 1.266 1.673 2.392 3.007 3.203 1.333.81 3.055 1.322 5.289 1.322a.479.479 0 0 1 0 .956c-4.042 0-6.522 1.69-8.01 3.776-1.41 1.98-1.943 4.342-2.004 6.024l-.006.326-.01.097a.479.479 0 0 1-.946-.097Z",
      style: {"fill":"color(display-p3 .432 .432 .72)","fill-opacity":"1","stroke":"color(display-p3 .432 .432 .72)","stroke-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }